export default __webpack_public_path__ + "images/models/d1edc739b378f6ecc475a3e8d6996477.usdz";